const {
  getToken,
  removePayOrderNo,
  setPaySuccessURL,
  setShoppingInfor,
} = require('@/utils/cookies')

const apiTeacherDetail = require('@/api/teacher').teacherDetail

module.exports = {
  data() {
    return {
      teacherList: [], // 老师列表
      tabsList: [], // tab列表数据
      tabsActiveIndex: 0, //tab选中下标
    }
  },
  computed: {
    // 解析html字符串中 body内容
    bodyInfo() {
      return (html) => {
        return this.$util.getHtmlStringBodyContent(html)
      }
    },
    // 清除位数零
    clearPriceZero() {
      return this.$util.clearPriceZero
    },
  },
  methods: {
    //判断是否是app
    isAPP() {
      if (window?.tikuWeb?.setShareHtml) {
        this.openApp()
        window.history.back()
        return true
      }
      if (window?.webkit?.messageHandlers?.canLoadShare) {
        window.history.back()
        this.openApp()
        return true
      }
      return false
    },
    // 获取老师列表
    getTeacherDetail(list) {
      if (!list || list.length <= 0) return
      let id = list.join(',')
      apiTeacherDetail(this.routeFixedParam({ id })).then((res) => {
        this.teacherList = res.data
      })
    },
    // 商品数据格式化 中间件
    dataGoodsFormatMiddle(data) {
      let unitName = this.$route.params.unitName
      let dataGoods = {}

      // 商品数据格式化
      if (unitName == 'identity') {
        dataGoods = Object.assign(data, data.rights) || {}
      } else {
        dataGoods = data
      }
      this.dataGoodsFormat(dataGoods)
    },

    tabsListFactory(dataKeyName, name, listKey) {
      return { dataKeyName, name, listKey }
    },

    // 商品数据格式化
    dataGoodsFormat(sourceData) {
      let tabsListFactory = this.tabsListFactory,
        data = sourceData,
        tabsList = [],
        contentList = [
          tabsListFactory('intro', '课程介绍', 'intro'),
          tabsListFactory('teacher_list', '老师简介', 'teacher_list'),
          tabsListFactory('group', '选课', 'group'),
        ]

      if (this.is_buy) {
        contentList.shift()
      }
      contentList.forEach(function (item) {
        let list = data[item.dataKeyName]

        if (list && list.length > 0) {
          tabsList.push({
            name: item.name,
            listKey: item.listKey,
            list: list,
          })
        }
      })
      this.tabsList = tabsList
      this.goodsData = data
      if (data.detail_show_type === 2 && data.name_prefix) {
        const { font_color, bg_color } = data.name_prefix
        this.bgLabel.color = font_color
        this.bgLabel.backgroundColor = bg_color
      }
      this.selectCourse()
    },
    // 选择课程列表数据
    selectCourse() {
      if (this.goodsData.group.length) {
        this.courseAllList = this.goodsData.group.map((item) => {
          let obj = {
            name: item.name,
            list: this.goodsData.list.filter((i) => item.no_list.find((ite) => ite === i.no)),
          }
          return obj
        })
      } else {
        this.courseAllList = [{ name: '', list: this.goodsData.list }]
      }
      console.log(this.courseAllList, this.result, '课程数据')
    },
    // 刷新商品信息
    updateGoodsProduct(product = {}) {
      if (!product) return
      this.productCase = product
    },
    // 刷新商品购买状态
    updateGoodsBuySate(isBuy) {
      this.is_buy = isBuy
    },

    // 检查用户是不是没有登录
    checkUserNotLogin() {
      let query = this.routeFixedParam()
      // 当前没有登录时，直接跳转登录页
      if (!getToken()) {
        this.$router.push({ name: 'login', query })
        return true
      }
    },
    // 写入成功支付成功回调地址
    setPaySuccessURLFn() {
      let successURL = window.location.href
      // 系列课默认不跳回选课界面
      successURL = successURL.replace(/&isChooseCourse=true/g, '')
      setPaySuccessURL(successURL)
    },
    goPay(params = []) {
      /*============================线上商品=================================*/
      // 页面跳转参数
      let query = this.routeFixedParam()

      // 清除上次购买的订单号
      removePayOrderNo()

      // 写入商品信息
      setShoppingInfor(params)
      this.setPaySuccessURLFn()

      // 按钮防抖
      this.isDisableButton = true
      setTimeout(() => {
        this.isDisableButton = false
      }, 2000)

      // 微信内置浏览器执行方法
      if (this.$browser.isWXBrowser()) {
        query.pay_scheme = this.goodsData?.product?.pay_scheme || ''
        let url = this.$brandConfig.getWxOpenidURL(query)
        this.$util.windowLocationHref(url)
        return
      }

      // 当前路由全路径
      query.beforeRouteFullPath = this.$route.fullPath

      // 一般跳转
      this.$router.push({
        path: '/play/payment',
        query: query,
      })
    },
  },
}
